/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { useState, useEffect } from "react"
import { Spacer, Spinner } from "@cd2/components"

import { Logo } from "./Logo"
import { useTheme } from "@cd2/theme"

interface IProps {
  alternativeText?: string
}
export function SplashScreen({ alternativeText }: IProps) {
  const { themeColor } = useTheme()

  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowSpinner(true)
    }, 1000)
    return () => clearTimeout(timeout)
  }, [])

  return (
    <div
      css={css`
        position: fixed;
        z-index: 999999;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background: ${themeColor("primary")};
        padding-top: calc(25vh);
      `}
    >
      <Logo height={100} alternativeText={alternativeText} vertical />
      <Spacer size={64} />
      <div
        css={css`
          margin: 0 auto;
          height: 40px;
          width: 40px;
          opacity: ${showSpinner ? 100 : 0}%;
        `}
      >
        <Spinner />
      </div>
    </div>
  )
}
